import { useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import { getSecPermission, isEmptyDash, NumberToampm, strToDate } from "../../constant";

function TrackOrder(props) {
    const [refresh, setRefresh] = useState(false);
    const handleRefresh = () => {
        setRefresh(prev => !prev);
        props.refresh();
    };
    return (
        <Box
            sx={{
                width: 350,
                zIndex: 1300,
            }}
            role="presentation"
        >
            <List>
                <div className="row_order_sidebar_bdpt_po_div">
                    <div className="track_order_form_bdpt_sm">
                        <h6 className="main_heading_trackordertexr">Track Order</h6>
                        <div>
                            <CachedOutlinedIcon onClick={handleRefresh} />
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={props.close}
                            ></button>
                        </div>
                    </div>
                    <div className="track_order_row_bpdt_react">
                        <div>
                            <h6 className="username_bpdt_div_react">PO Number</h6>
                            <p className="username_bpdt_div_react_row1">{(props?.steps?.poNumber) ? props?.steps?.poNumber : ''}</p>
                        </div>
                        <div>
                            <h6 className="username_bpdt_div_react">Status</h6>
                            <p className="date_solutions_status_row">{(props?.steps?.status) ? props?.steps?.status : ''}</p>
                        </div>
                    </div>
                    <div className="track_order_row_bpdt_react">
                        <div>
                            <h6 className="username_bpdt_div_react">Creation Date</h6>
                            <p className="username_bpdt_div_react_row1">{(props?.steps?.creationDate) ? strToDate(props?.steps?.creationDate) : ''}</p>
                        </div>
                        <div>
                            <h6 className="username_bpdt_div_react">Target Date</h6>
                            <p className="username_bpdt_div_react_row1">{(props?.steps?.targetDate) ? strToDate(props?.steps?.targetDate) : ''}</p>
                        </div>
                        <div>
                            <h6 className="username_bpdt_div_react">Delivery Date</h6>
                            <p className="username_bpdt_div_react_row1">{(props?.steps?.deliveryDate) ? strToDate(props?.steps?.deliveryDate) : 'N/A'}</p>
                        </div>
                    </div>
                </div>
            </List>
            <Divider />
            <List>
                <div>
                    <Box className="po_detail_bfdt_row_div_sidebar1 trackorder_section">
                        {props?.steps?.trackOrders && (
                            // Group steps based on consecutive eventTypes
                            props.steps.trackOrders.reduce((acc, step, index, arr) => {
                                const prevStep = arr[index - 1];
                                const isSameTypeAsPrevious = prevStep && prevStep.eventType === step.eventType;
                                // If the current eventType is the same as the previous, add it to the last group
                                if (isSameTypeAsPrevious) {
                                    acc[acc.length - 1].push(step);
                                } else {
                                    // Start a new group
                                    acc.push([step]);
                                }

                                return acc;
                            }, []).map((group, groupIndex) => {
                                const eventType = group[0].eventType;
                                return (
                                    <Stepper orientation="vertical" key={groupIndex}>
                                        {group.length > 1 ? (
                                            <Step style={{ display: "-webkit-box" }}>
                                                <StepLabel>
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`panel${groupIndex}-content`}
                                                            id={`panel${groupIndex}-header`}
                                                        >
                                                            {eventType}
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            {group.map((step, stepIndex) => (
                                                                <div key={stepIndex}>
                                                                    <Typography sx={{ mt: 1 }}>{step.referenceNumber}</Typography>
                                                                    {step.createdOn && (
                                                                        <Typography sx={{ mt: 1 }}>Created on: {strToDate(step.createdOn)}</Typography>
                                                                    )}
                                                                    {step.createdBy && (
                                                                        <Typography sx={{ mt: 1 }}>Created By: {step.createdBy}</Typography>
                                                                    )}
                                                                    {step.createdAt && (
                                                                        <Typography sx={{ mt: 1 }}>Created on: {step.createdAt}</Typography>
                                                                    )}
                                                                    <hr></hr>
                                                                </div>
                                                            ))}
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </StepLabel>
                                            </Step>
                                        ) : (
                                            group.map((step, stepIndex) => (
                                                <Step style={{ display: "-webkit-box" }} key={stepIndex}>
                                                    <div>
                                                        <StepLabel>{eventType}</StepLabel>
                                                        <StepContent>
                                                            <Typography sx={{ mt: 1 }}>{step.referenceNumber}</Typography>
                                                            {step.createdAt && (
                                                                <Typography sx={{ mt: 1 }}>Created on: {strToDate(step.createdAt)}</Typography>
                                                            )}
                                                            {step.createdBy && (
                                                                <Typography sx={{ mt: 1 }}>Created By: {step.createdBy}</Typography>
                                                            )}
                                                            {step.createdAt && (
                                                                <Typography sx={{ mt: 1 }}>Created at: {NumberToampm(step.createdAt)}</Typography>
                                                            )}
                                                        </StepContent>
                                                    </div>
                                                </Step>
                                            ))
                                        )}
                                    </Stepper>
                                );
                            })
                        )}
                    </Box>
                </div>
            </List>

        </Box>
    );
}

export default TrackOrder;